/**
 * @generated SignedSource<<11ccb38f6c2d8f63c8482a6d5f9dc9be>>
 * @relayHash d7ec16f632bb3e2651dd2f1109ec80bc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d9768ed6336faee0207750f0fe7e583b66542151bc1c79447c66bad6f75cabff

import type { ConcreteRequest } from 'relay-runtime';
export type LegacyProjectFieldsPageMountEfaOptInMenuItemQuery$variables = {
  cloudId: string;
  isJiraEfaForCmpM2Experiment: boolean;
};
export type LegacyProjectFieldsPageMountEfaOptInMenuItemQuery$data = {
  readonly jira_isTenantConvertedToNfa?: boolean | null;
};
export type LegacyProjectFieldsPageMountEfaOptInMenuItemQuery = {
  response: LegacyProjectFieldsPageMountEfaOptInMenuItemQuery$data;
  variables: LegacyProjectFieldsPageMountEfaOptInMenuItemQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isJiraEfaForCmpM2Experiment"
  }
],
v1 = [
  {
    "condition": "isJiraEfaForCmpM2Experiment",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          }
        ],
        "kind": "ScalarField",
        "name": "jira_isTenantConvertedToNfa"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "LegacyProjectFieldsPageMountEfaOptInMenuItemQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LegacyProjectFieldsPageMountEfaOptInMenuItemQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "d9768ed6336faee0207750f0fe7e583b66542151bc1c79447c66bad6f75cabff",
    "metadata": {},
    "name": "LegacyProjectFieldsPageMountEfaOptInMenuItemQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "a159efa8fe9932287e93aec00f2ba5fb";

export default node;
